import React, { useEffect, useState } from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import UploadDisabledForm from './UploadDisabledForm';
import { getKeyProviders } from '../../../actions/keyProviderActions';
import { useForm } from 'react-hook-form';
import Loading from '../../common/Loading';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { uploadDisabled } from '../../../api/keyCodeApi';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { fetchDisableReasons } from '../../../reducers/disableReasonReducer';

export interface UploadDisabledProps {
  done: () => void;
  cancel: () => void;
}

function UploadDisabled({ done, cancel }: UploadDisabledProps) {
  const disableReasons = useAppSelector((state) => state.disableReasons);
  const keyProviders = useAppSelector((state) => state.keyProviders);
  const dispatch = useAppDispatch();

  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
    getValues,
  } = useForm();
  const [disabledFiles, setDisabledFiles] = useState<any[]>([]);

  const addFiles = (files: any[]) => {
    setDisabledFiles((prevFiles) => [...prevFiles, ...files]);
  };
  const removeFile = (file: any) => {
    setDisabledFiles((prevFiles) =>
      prevFiles.filter((prevFile) => prevFile !== file)
    );
  };

  const onSubmit = (data: any) => {
    Promise.all(disabledFiles.map((file) => uploadDisabled({ file, ...data })))
      .then(() => {
        toast.success(t('Disabled keys successfully uploaded'));
        done();
      })
      .catch((e) => {
        toast.error(e.message || t('Failed to upload disabled keys'));
      });
  };

  useEffect(() => {
    if (!keyProviders) {
      dispatch(getKeyProviders());
    }
  }, [keyProviders, dispatch]);

  useEffect(() => {
    if (!disableReasons) {
      dispatch(fetchDisableReasons());
    }
  }, [disableReasons, dispatch]);

  return keyProviders ? (
    <SlideoutLayout
      title={t('Upload disabled keys')}
      cancel={cancel}
    >
      <UploadDisabledForm
        keyProviders={keyProviders}
        disableReasons={disableReasons}
        register={register}
        errors={errors}
        control={control}
        cancel={cancel}
        submit={handleSubmit(onSubmit)}
        addFiles={addFiles}
        removeFile={removeFile}
        setValue={setValue}
        getValues={getValues}
        disabledFiles={disabledFiles}
      />
    </SlideoutLayout>
  ) : (
    <Loading />
  );
}

export default UploadDisabled;
